<div class="row"
  [class.ops]="isCreditCardProcessing">
  <span style="width: 100%;" [innerHtml]="'shoppingCart.checkout.warning' | translate"></span>
  <div class="col">
    <mat-card appearance="outlined">
      <mat-card-content>
        @if (paymentError) {
          <div
            class="alert alert-danger"
            role="alert">
            {{paymentErrorMessage}}
            <button mat-flat-button (click)="retryPayment()">{{'navigation.retry' | translate}}</button>
          </div>
        }
        <h2>{{ 'shoppingCart.checkout.title' | translate }}</h2>
        @if (!totalAmount) {
          <div class="row" style="padding-bottom: 100px;">
            <div class="spinner-container" >
              <mat-spinner></mat-spinner>
            </div>
          </div>
        }
        @if (totalAmount && isPaymentAvailable) {
          <div class="row"
            >
            <div class="col">
              <span class="font-weight-bold text-danger" [innerHTML]="'shoppingCart.checkout.amountToPay' | translate:{amount: totalAmount }"></span>
              <odq-payment [monerisStoreId]="storeId" (dataKeyCreated)="doPayment($event)"></odq-payment>
            </div>
            <div class="col">
              <mat-card appearance="outlined">
                <mat-card-header>
                  {{ 'shoppingCart.checkout.transactionDetails.title' | translate }}
                </mat-card-header>
                <mat-card-content>
                  <div class="flexbox-container d-flex flex-column">
                    @for (cartItem of cartItems; track cartItem) {
                      <div class="flex-items d-flex flex-row justify-content-between"
                        >
                        <div class="text-right mr-2">{{cartItem.quantity }}</div>
                        <div class="flex-fill"
                          [innerHTML]="'shoppingCart.checkout.transactionDetails.item' | translate:{title: cartItem.description, price: cartItem.unitPrice }">
                        </div>
                        <div class="ml-2 text-right">{{getAmount(cartItem.total)}}</div>
                      </div>
                    }
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        }
        @if (isCreditCardProcessing) {
          <div
            class="spinner-container">
            <mat-spinner [diameter]="10"></mat-spinner>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
